export default "__VITE_ASSET__1QC2nFHb__"